<template>
  <div class="np-page np-checkout">
    <header class="np-site-header">
      <div class="np-site-header-brand">
        <img class="np-site-logo" src="@/assets/img/brand/novapay-logo.jpg" alt="NovaPay" />
        <div>
          <div class="np-site-name">NovaPay</div>
        </div>
      </div>
    </header>

    <div class="np-card np-checkout-hero">
      <div class="np-status-icon">
        <img src="@/assets/img/pay/success.png" alt="success" />
      </div>
      <h1 class="np-status-title">Payment Success</h1>
      <p class="np-status-desc">Your deposit has arrived.</p>
      <div class="np-meta-chip">
        <span class="dot"></span>
        <span>Secure payment</span>
      </div>
      <div class="np-upi-bhim-logo">
        <img src="@/assets/img/pay/logo_upi_bhim.png" alt="UPI BHIM" />
      </div>
    </div>

    <div class="np-card">
      <div class="np-card-title">Details</div>
      <van-steps direction="vertical" :active="1">
        <van-step>
          <div class="np-detail-label">Status</div>
          <div class="np-detail-value success">Arrived</div>
        </van-step>
        <van-step>
          <div class="np-detail-label">Arrival Time</div>
          <div class="np-detail-value">
            {{
              state.orderInfo.successTime
                ? Util.filterTimes(state.orderInfo.successTime, "america")
                : "-"
            }}
          </div>
        </van-step>
      </van-steps>
    </div>

    <div class="np-bottom-actions">
      <van-button type="primary" block class="np-btn-primary" @click="goApp">
        Return to App
      </van-button>
      <p class="np-bottom-actions-note">Return and check your balance</p>
    </div>
  </div>
</template>

<script setup>
import { reactive, onMounted, onUnmounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import { Util } from "@/common/js/utils.js";
import Axios from "@/axios";
import { decrypt } from "@/common/js/utils.js";

let interVal;
const route = useRoute();
const router = useRouter();

let state = reactive({
  type: route.query.type,
  utrData: window.globalUtrData || {},
  id: route.query.id,
  orderInfo: {},
});

onMounted(async () => {
  document.title = "deposit";
  queryOrder();
  const cacheData = sessionStorage.getItem("checkOutData");
  if (cacheData && cacheData != "undefined") {
    state.orderInfo = JSON.parse(cacheData);
  }
});

const queryOrder = async () => {
  try {
    let res = await Axios("post", "/safe/query", { id: state.id });
    if (res.code === 200) {
      res.result = JSON.parse(decrypt(res.result, state.id));
      state.orderInfo = res.result;
      if ([1].includes(res.result.status)) {
        state.type = "success";
      }
    } else if (res.code !== 200) {
      router.push(`/expired`);
    }
  } catch (error) {}
};

const goApp = () => {
  window.location.href = state.orderInfo.skipUrl;
};

onUnmounted(() => {
  if (interVal) {
    clearTimeout(interVal);
  }
});
</script>

<style scoped lang="less">
.np-checkout {
  padding-bottom: 120px;
  background:
    radial-gradient(circle at 50% 0%, rgba(134, 73, 230, 0.16) 0, rgba(134, 73, 230, 0) 260px),
    linear-gradient(180deg, #f7f3ff 0%, var(--np-bg-page) 100%);
}
.np-checkout-hero {
  text-align: center;
}
.np-checkout :deep(.np-card) {
  border-color: var(--np-border);
  box-shadow: var(--np-shadow-card);
}
.np-checkout :deep(.np-status-icon) {
  background: linear-gradient(180deg, #f2eaff 0%, #e7ddfb 100%);
}
.np-checkout :deep(.van-step__circle),
.np-checkout :deep(.van-step__line) {
  background: var(--np-primary);
}
.np-checkout :deep(.van-step__title--active),
.np-checkout :deep(.van-step__title) {
  color: var(--np-text);
}
.np-detail-label {
  font-size: 12px;
  font-weight: 700;
  color: var(--np-text-secondary);
  margin-bottom: 4px;
}
.np-detail-value {
  font-size: 14px;
  font-weight: 800;
  color: var(--np-text);
}
.np-detail-value.success {
  color: var(--np-primary);
}
</style>
